module.exports = __webpack_public_path__ + "static/img/4354_phase_function_Paper_Points.5b7ed03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4354_phase_function_Paper_Points.png
// module id = N/MW
// module chunks = 0